
























import { Vue, Component } from "vue-property-decorator";
import { mapGetters } from "vuex";
import store from "../core/store";

import { Getter } from "vuex-class";

@Component({
  computed: {
    ...mapGetters([
      "hasUser",
      "isInternalUser",
      "isAdminUser",
      "hasPost",
      "hasTopicPulse",
      "hasTopLine"
    ])
  }
  // async mounted() {
  //   await store.dispatch("fetchPortalData");
  // }
})
export default class PortalLayout extends Vue {
  @Getter("hasPost")
  hasPost?: boolean;
  @Getter("hasTopLine")
  hasTopLine?: boolean;
  @Getter("hasTopicPulse")
  hasTopicPulse?: boolean;
  @Getter("hasUsers")
  hasUsers?: boolean;

  logout() {
    store.dispatch("logout");
  }
}
